import * as React from 'react';
import { Bem } from '../../utils/css.js';
import '../../constants.js';
import './NavigationScrollbar.scss.js';

const calculateStyles = ({ scrollHeight, clientHeight, scrollTop }) => {
  if (clientHeight && scrollHeight && clientHeight < scrollHeight) {
    const sizeRatio = clientHeight / scrollHeight;
    const styles = {
      height: `${sizeRatio * clientHeight}px`,
      marginTop: `${scrollTop}px`
    };
    if (scrollTop) {
      return { ...styles, top: `${scrollTop * sizeRatio}px` };
    }
    return { ...styles };
  }
  return { height: "0" };
};
const bem = Bem.create("vai-navigation-scrollbar");
const NavigationScrollbar = (props) => {
  const style = React.useMemo(() => calculateStyles(props), [props]);
  return /* @__PURE__ */ React.createElement("div", {
    className: bem.block()
  }, /* @__PURE__ */ React.createElement("div", {
    className: bem.element("thump")(),
    style
  }));
};

export { NavigationScrollbar, calculateStyles };
